import { useNavigate } from 'react-router-dom'

import { Icon } from '@paysense-india-services/elevate-web'

import isWeblinkAction from '../../utils'

import styles from './index.module.scss'

const RowItem = ({ item, onClick }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick(item)
    } else {
      const defaultAction = item?.actions?.default
      const url = defaultAction?.url
      if (!url) return

      if (isWeblinkAction(defaultAction)) {
        window.open(url, '_blank', 'noopener,noreferrer')
      } else {
        navigate(url)
      }
    }
  }

  return (
    <button
      aria-label={item.title || 'Open'}
      className={`${styles.rowButton} ew-d-flex ew-align-items-center ew-gap-16 ew-cursor-pointer`}
      onClick={handleClick}
      type='button'>
      {item.assets?.leadingIcon ? (
        <div className='ew-d-flex ew-align-items-center ew-justify-content-center ew-rounded-md ew-p-8'>
          <img alt='' height={24} src={item.assets.leadingIcon} width={24} />
        </div>
      ) : null}

      <div className='ew-typography-small ew-fw-regular ew-color-primary ew-flex-grow-1'>
        {item.title}
      </div>

      {item.showArrow ? (
        <div
          className={`ew-d-flex ew-align-items-center ew-justify-content-center ew-bg-secondary ${styles.arrowContainer}`}>
          <Icon fill='#171717' name='rightArrowHead' size={14} />
        </div>
      ) : null}
    </button>
  )
}

export default RowItem
